module.exports = __webpack_public_path__ + "img/photo-1.88f07cc3.jpg";